"use client";

import { useEffect } from "react";

const SITE_HEADER_SELECTOR = "[data-site-header]";
const SITE_HEADER_HEIGHT_CSS_VARIABLE = "--site-header-height";

export function HeaderHeightObserver() {
  useEffect(() => {
    const header = document.querySelector<HTMLElement>(SITE_HEADER_SELECTOR);

    if (!header) {
      return;
    }

    const root = document.documentElement;
    let animationFrameId: number | null = null;

    const syncHeaderHeight = () => {
      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = window.requestAnimationFrame(() => {
        root.style.setProperty(
          SITE_HEADER_HEIGHT_CSS_VARIABLE,
          `${header.getBoundingClientRect().height}px`
        );
        animationFrameId = null;
      });
    };

    syncHeaderHeight();

    const resizeObserver =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(syncHeaderHeight);

    resizeObserver?.observe(header);
    window.addEventListener("resize", syncHeaderHeight);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", syncHeaderHeight);
      root.style.removeProperty(SITE_HEADER_HEIGHT_CSS_VARIABLE);

      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return null;
}
